import React, {useEffect} from 'react';

import '../../App.css';
import {useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {Status} from "../../feature/project/status";
import {ViewMode} from "../common/ViewMode";
import {List, NumericList} from "../common/ListItems";
import {fetchShots} from "../../feature/project/shotSlice";

const Shots = (props: {}) => {

    const dispatch = useAppDispatch()
    const {projectId, actId, storyId, chapterId, sceneId} = useParams();
    const shots = useAppSelector(state => state.shots.shots)
    const status = useAppSelector(state => state.shots.status)

    useEffect(() => {
        if (status === Status.Idle && projectId && sceneId) {
            dispatch(fetchShots({projectId: parseInt(projectId), sceneId: parseInt(sceneId)}))
        }
    }, [status, projectId, sceneId, dispatch])

    return (
        <NumericList
            items={shots.map(shot => ({...shot, title: shot.environment + " - " + shot.place + " - " + shot.time}))}
            path={(id) => `/projects/${projectId}/stories/${storyId}/acts/${actId}/chapters/${chapterId}/scenes/${sceneId}/shots/${id}`}
        />
    );
}

export default Shots;